import { Link, Outlet, useParams } from "react-router-dom";

const ViewOrder = () => {
  const { orderId } = useParams();

  return (
    <div>
      <h2 className="order-detail-header">Order Details: {orderId}</h2>
      
      <nav className="order-detail-nav">
        <Link to="track" className="order-tab">Track</Link>
        <Link to="replace" className="order-tab">Return/Replace</Link>
        <Link to="invoice" className="order-tab">Invoice</Link>
      </nav>

      <div className="order-detail-content">
        <Outlet /> {/* Render Track, Replace, or Invoice here */}
      </div>
    </div>
  );
};

export default ViewOrder;
